import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconSms = memo(
  forwardRef((props, ref) => (
    <SvgIcon {...props} ref={ref} viewBox="0 0 30 30" data-fill-none>
      <path
        d="M24.8427 4.91699H4.58755C4.26305 4.91699 4 5.18005 4 5.50454V17.4416V20.0295C4 20.354 4.26305 20.6171 4.58755 20.6171H10.0084V24.5379C10.0084 24.7719 10.2686 24.9119 10.4639 24.7831L16.7778 20.6171H24.8427C25.1672 20.6171 25.4303 20.354 25.4303 20.0295V5.50454C25.4303 5.18005 25.1672 4.91699 24.8427 4.91699Z"
        stroke="#2F393E"
        strokeLinejoin="round"
      />
      <path
        d="M10.6411 12.6322C10.6411 13.278 10.07 13.8015 9.36545 13.8015C8.66095 13.8015 8.08984 13.278 8.08984 12.6322C8.08984 11.9864 8.66095 11.4629 9.36545 11.4629C10.07 11.4629 10.6411 11.9864 10.6411 12.6322Z"
        fill="#2F393E"
      />
      <path
        d="M15.7465 12.6322C15.7465 13.278 15.1754 13.8015 14.4709 13.8015C13.7664 13.8015 13.1953 13.278 13.1953 12.6322C13.1953 11.9864 13.7664 11.4629 14.4709 11.4629C15.1754 11.4629 15.7465 11.9864 15.7465 12.6322Z"
        fill="#2F393E"
      />
      <path
        d="M20.8403 12.6322C20.8403 13.278 20.2692 13.8015 19.5647 13.8015C18.8602 13.8015 18.2891 13.278 18.2891 12.6322C18.2891 11.9864 18.8602 11.4629 19.5647 11.4629C20.2692 11.4629 20.8403 11.9864 20.8403 12.6322Z"
        fill="#2F393E"
      />
    </SvgIcon>
  ))
);
